define("shared/components/shared/upgrade/trial-monthly-price", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span
    class="tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs u--text--hair qa--price_starting_point_text"
  >
    {{t "authorization.sign_up_trial.from"}}
  </span>
  <div class="tPF--plan__price u--m__t__xs u--text--hair">
    <sup class="tPF--plan__priceCurrency">{{t "plans.currency_symbol"}}</sup>
    <span class="tPF--plan__priceValue tPF--plan__priceValue--xs u--text--strike qa--plan__price">
      {{div @monthlyPrice 100}}
    </span>
    <span class="tPF--plan__priceDuration">{{t "plans.per_month_alt"}}</span>
    {{svg-jar "arrow-right" class="o--icon--lg o--icon--light tPF--plan__priceIcon"}}
    <span class="tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price">
      {{html-safe (t "authorization.sign_up_trial.try_free")}}
    </span>
  </div>
  */
  {
    "id": "kDwf/JB/",
    "block": "[[[10,1],[14,0,\"tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs u--text--hair qa--price_starting_point_text\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"authorization.sign_up_trial.from\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"tPF--plan__price u--m__t__xs u--text--hair\"],[12],[1,\"\\n  \"],[10,\"sup\"],[14,0,\"tPF--plan__priceCurrency\"],[12],[1,[28,[35,0],[\"plans.currency_symbol\"],null]],[13],[1,\"\\n  \"],[10,1],[14,0,\"tPF--plan__priceValue tPF--plan__priceValue--xs u--text--strike qa--plan__price\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[[30,1],100],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"tPF--plan__priceDuration\"],[12],[1,[28,[35,0],[\"plans.per_month_alt\"],null]],[13],[1,\"\\n  \"],[1,[28,[35,2],[\"arrow-right\"],[[\"class\"],[\"o--icon--lg o--icon--light tPF--plan__priceIcon\"]]]],[1,\"\\n  \"],[10,1],[14,0,\"tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[[28,[37,0],[\"authorization.sign_up_trial.try_free\"],null]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@monthlyPrice\"],false,[\"t\",\"div\",\"svg-jar\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/upgrade/trial-monthly-price.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});